export default __webpack_public_path__ + "static/media/footer-telefone.b21af006.svg";